<template>
  <div>
    <ValidationObserver ref="observer">
      <v-row justify="center">
        <v-col cols="12">
          <div
            class="
              text-start
              mb-0
              textLight--text
              text-subtitle-2
              font-weight-thin
            "
          >
            {{ $t("user.detailSignUp.setProfilePhoto") }}
          </div>
          <div class="d-flex mt-3">
            <image-uploader
              id="logo"
              :maxWidth="1024"
              :maxHeight="1024"
              :quality="0.9"
              :autoRotate="true"
              outputFormat="blob"
              :preview="false"
              :className="['fileinput', { 'fileinput--loaded': hasLogo }]"
              capture="false"
              accept="image/*"
              doNotResize="['gif', 'svg']"
              @input="setLogo"
            >
              <label for="logo" slot="upload-label">
                <a>
                  <v-img
                    v-if="logoUrl"
                    class="image-custom-preview"
                    :src="logoUrl"
                  >
                  </v-img>
                  <div v-if="!hasLogo" class="upload-caption gray1--text">
                    <v-avatar tile v-if="data.image" :size="100"
                      ><v-img :src="getImage(data.image)"> </v-img
                    ></v-avatar>
                    <v-avatar
                      tile
                      color="#F5F1FF"
                      v-else
                      :size="100"
                      class="rounded-lg"
                    >
                      <v-icon size="50" color="#281166" style="opacity: 0.2"
                        >mdi-account-circle-outline</v-icon
                      >
                    </v-avatar>
                  </div>
                </a>
                <v-img
                  class="mt-4"
                  width="150"
                  :src="require('@/app/user-module/assets/images/Button.png')"
                ></v-img>
              </label>
            </image-uploader>
          </div>
          <!-- <div class="d-flex" slot="upload-label">
            <v-btn width="150" class="rounded-lg" outlined color="textLight">
              Upload
            </v-btn>
          </div> -->
        </v-col>
        <!-- <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required">
            <div
              class="
                text-start
                mb-0
                textLight--text
                text-subtitle-2
                font-weight-thin
              "
            >
              {{ $t("user.company") }}
            </div>
            <v-autocomplete
              readonly
              hide-details
              v-model="data.organization"
              :error-messages="errors"
              @click="error = false"
              outlined
              :items="organizations"
              item-value="id"
              :item-text="$vuetify.rtl ? 'ar' : 'en'"
              dense
              class="rounded-md text-body-2"
            ></v-autocomplete>
          </validation-provider>
        </v-col> -->
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required">
            <div
              class="
                text-start
                mb-0
                textLight--text
                text-subtitle-2
                font-weight-thin
              "
            >
              {{ $t("user.designation") }}
            </div>
            <v-text-field
              hide-details
              v-model="data.designation"
              :error-messages="errors"
              @click="error = false"
              outlined
              :append-icon="
                !data.email && error ? 'mdi-alert-circle-outline' : null
              "
              dense
              class="rounded-md text-body-2"
            >
            </v-text-field>
          </validation-provider>
        </v-col>
        <v-col cols="12">
          <v-btn
            depressed
            dense
            dark
            class="text-subtitle-1 rounded-md mb-2 mt-5"
            color="textLight"
            style="width: 100%"
            @click="submit"
          >
            {{ $t("user.signUp.signUp").toUpperCase() }}
          </v-btn>
        </v-col>
      </v-row>
    </ValidationObserver>
    <CropperModal ref="cropperModal" @croppedData="croppedData" />
  </div>
</template>
<script>
import imageUploader from "vue-image-upload-resize";
import CropperModal from "../../core-module/components/CropperModal.vue";
export default {
  props: {
    values: {
      type: Object,
    },
  },
  data() {
    return {
      error: false,
      data: this.values,
      // organizations: [],
      logoUrl: null,
      hasLogo: false,
      imageUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  components: {
    imageUploader,
    CropperModal,
  },
  // apollo: {
  //   getOrganizations() {
  //     return {
  //       query: require("@/app/user-module/api/query/getOrganizations.gql"),
  //       variables: {
  //         limit: 0,
  //         skip: 0,
  //       },
  //       result({ data }) {
  //         if (
  //           data &&
  //           data.getOrganizations &&
  //           data.getOrganizations.organizations
  //         ) {
  //           this.organizations = data.getOrganizations.organizations.map(
  //             obj => {
  //               let organization = {};
  //               organization.id = obj._id;
  //               obj.name.map(val => {
  //                 organization[val.lang] = val.value;
  //               });
  //               return organization;
  //             }
  //           );
  //         }
  //       },
  //     };
  //   },
  // },
  methods: {
    setLogo(output) {
      this.hasLogo = true;
      var reader = new FileReader();
      reader.readAsDataURL(output);
      var self = this;

      reader.onloadend = function () {
        var base64data = reader.result;
        // self.categoryInput.url = base64data;
        self.logoUrl = base64data;
        self.$refs.cropperModal.show(self.logoUrl);
      };
      this.data.image = output;
    },
    croppedData(blobData, base64Data) {
      this.data.image = blobData;
      this.logoUrl = base64Data;
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) this.error = true;
      else this.$emit("completed2", this.data);
    },
  },
};
</script>
<style>
#fileInput {
  display: none;
}

#logo {
  display: none;
}
</style>
<style scoped>
.image-custom-preview {
  height: 100px !important;
  width: 100px !important;
  border-radius: 10px;
}
</style>
